import LeftModal from './LeftModal'

export default LeftModal
